import { autoinject } from "aurelia-framework";
import "./comp-theme-picker.scss";

@autoinject
export class CompThemePicker {
    
    public theme: string;

    constructor(){}

    attached() {
        this.changeTheme('yellow');
    }

    changeTheme(theme) {
        const classList = document.documentElement.classList;
        this.theme = theme;
        
        if (theme === 'red') {
            classList.remove('blue', 'green', 'yellow');
            classList.add('red');
        }
        else if (theme === 'blue') {
            classList.remove('red', 'green', 'yellow');
            classList.add('blue');
        }
        else if (theme === 'green') {
            classList.remove('red', 'blue', 'yellow');
            classList.add('green');
        }
        else if (theme === 'yellow') {
            classList.remove('red', 'blue', 'green');
            classList.add('yellow');
        }    
    }
}